module.exports = __webpack_public_path__ + "img/confirmID_2-2.391e56a2.webp";